module.exports = __webpack_public_path__ + "static/img/mission.ece958b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mission.png
// module id = c9Eb
// module chunks = 2